import { getPublicOrgUnit } from 'lib/requests'
import { useEffect, useState } from 'react'
import useSWR from 'swr'

export default function useOrgUnit(orgUnitSlug) {
  const [loading, setLoading] = useState(true)
  const { error, data: orgUnit } = useSWR(orgUnitSlug, getPublicOrgUnit)

  useEffect(() => {
    setLoading(true)
  }, [orgUnitSlug])

  useEffect(() => {
    if (error || orgUnit !== undefined) {
      setLoading(false)
    }
  }, [error, orgUnit])

  return { loading, ou: orgUnit }
}
